import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Field } from "react-final-form";
import { Capacity } from "@soqs/common";

const CapacitySelector = (props) => {
  let { disabled } = props;

  const required = (value) => (value ? undefined : "Required");
  return (
    <Field
      required
      name="Capacity"
      validate={required}
      component={CapacitySelectorAdapter}
      disabled={disabled}
      subscription={{ touched: true, value: true, error: true }}
    />
  );
};

const CapacitySelectorAdapter = ({
  name,
  input,
  meta,
  options,
  label,
  disabled,
  ...rest
}) => {
  return (
    <>
      <RadioGroup
        aria-labelledby="radio-buttons-group"
        name="capacity"
        {...input}
        {...rest}
        defaultChecked="true"
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel
          value={Capacity.Taxpayer} //table 18
          aria-label="Taxpayer"
          control={<Radio />}
          label="Myself"
        />
        <FormControlLabel
          value={Capacity.TaxPractitioner} //table 18
          aria-label="Tax Practitioner"
          control={<Radio />}
          label="Someone else in my capacity as their Tax Practitioner"
        />
        <FormControlLabel
          value={Capacity.Representative} //table 18
          aria-label="Registered Representative"
          control={<Radio />}
          label="Someone else in my capacity as their Registered Representative"
        />
      </RadioGroup>
    </>
  );
};

export default CapacitySelector;
